import React from 'react';
import {BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css';
import Home from './pages/home/Home';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import Navbar from "./components/navbar/Navbar";
import Doctors from "./pages/doctors/Doctors";
import Services from "./pages/services/Services";

function App() {
  return (
     <BrowserRouter>
         <div className="app">
             <Navbar />
             <Routes>
                 <Route exact path="/" element={<Home />}/>
                 <Route path="/login" element={<Login />} />
                 <Route path="/register" element={<Register />} />
                 <Route path="/doctors" element={<Doctors />} />
                 <Route path="/services" element={<Services />} />
             </Routes>
         </div>
     </BrowserRouter>
  );
}

export default App;
